export const UserAgent = {
	iOS() {
		return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	},
	mobile() {
		return /(iPad|iPhone|iPod|Android)/g.test(navigator.userAgent);
	},
	getOperatingSystem(): OperatingSystem {
		const userAgentString = navigator.userAgent;
		if (/Windows/g.test(userAgentString)) {
			return "Windows";
		} else if (/(iPad|iPhone|iPod)/g.test(userAgentString)) {
			return "IOS";
		} else if (/Macintosh/g.test(userAgentString)) {
			return "Mac";
		} else if (/Android/g.test(userAgentString)) {
			return "Android";
		} else if (/CrOS/g.test(userAgentString)) {
			return "ChromeOS";
		} else if (/Linux/g.test(userAgentString)) {
			return "Linux";
		} else {
			return null;
		}
	},
	getFormFactor(): FormFactor {
		const userAgentString = navigator.userAgent;
		if (/(tablet|ipad|playbook|silk|Kindle)|(android(?!.*mobi))/i.test(userAgentString)) {
			return "Tablet";
		} else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgentString)) {
			return "Mobile";
		} else {
			return "Desktop";
		}
	},
	getBrowser() {
		var userAgentRef = navigator.userAgent,
			tem,
			regexMatch = userAgentRef.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

		if (/trident/i.test(regexMatch[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(userAgentRef) || [];
			return {
				name: "IE",
				version: tem[1] || "",
			};
		}

		if (regexMatch[1] === "Chrome") {
			tem = userAgentRef.match(/\bOPR|Edge\/(\d+)/);
			if (tem != null) {
				return {
					name: "Opera",
					version: tem[1],
				};
			}
		}

		regexMatch = regexMatch[2] ? [regexMatch[1], regexMatch[2]] : [navigator.appName, navigator.appVersion, "-?"];

		if ((tem = userAgentRef.match(/version\/(\d+)/i)) != null) {
			regexMatch.splice(1, 1, tem[1]);
		}

		let result: BrowserData = {
			name: regexMatch[0],
			version: parseInt(regexMatch[1]),
		};

		return result;
	},
};

export type OperatingSystem = "Windows" | "Mac" | "ChromeOS" | "Linux" | "Android" | "IOS" | null;
export type FormFactor = "Mobile" | "Tablet" | "Desktop";
interface BrowserData {
	name: string;
	version: number;
}
